import React from 'react';
import { useAuth } from '../../context/AuthContext';
import './DeveloperPortalLayout.css';

interface SettingsProps {
  onNavigate: (section: string) => void;
}

const Settings: React.FC<SettingsProps> = ({ onNavigate }) => {
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout();
  };

  return (
    <div className="settings">
      <div className="content-header">
        <h1>Settings</h1>
        <p>Manage your account settings and preferences</p>
      </div>
      
      <div className="settings-content">
        <div className="settings-section">
          <h2>Account Information</h2>
          <div className="info-card">
            <div className="info-item">
              <label>Name</label>
              <span>{user?.name || 'Not provided'}</span>
            </div>
            <div className="info-item">
              <label>Email</label>
              <span>{user?.email}</span>
            </div>
            <div className="info-item">
              <label>Account Type</label>
              <span>Business Account</span>
            </div>
          </div>
        </div>

        <div className="settings-section">
          <h2>Account Actions</h2>
          <div className="action-card">
            <div className="action-item">
              <div className="action-info">
                <h3>Sign Out</h3>
                <p>Sign out of your business account</p>
              </div>
              <button 
                className="btn-danger"
                onClick={handleLogout}
              >
                Sign Out
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;
